import { IOffer } from '../../../types/offer';

export function getSpecialty(offer: IOffer): string[] {
  if (!offer.specialty?.specialties) {
    return [];
  }

  return offer.specialty.specialties.reduce<string[]>((acc, value) => {
    if (value.rusName && acc.length < 2) {
      acc.push(value.rusName.toLowerCase());
    }

    return acc;
  }, []);
}
